import { useMemo } from 'react'
import { useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId } from '@/api/generated/company-management-user/company-management-user'
import type {PensionInsuranceEmployeeConfigModel, InsuranceServiceModuleModel} from '@/api/model'
import { unwrap } from '@/utils/unwrap.ts'

export function usePensionInsuranceConfigs(serviceModuleId: number) {
  const query = useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId(serviceModuleId)

  const configsByEmployeeId = useMemo(() => {
    const module = unwrap<InsuranceServiceModuleModel>(query.data)
    const configs = module?.pensionInsuranceEmployeeConfigs ?? []
    return new Map(
      configs
        .filter((c): c is PensionInsuranceEmployeeConfigModel & { employeeUserId: string } => c.employeeUserId != null)
        .map((c) => [c.employeeUserId, c])
    )
  }, [query.data])

  return {
    pensionConfigsByEmployeeId: configsByEmployeeId,
    isLoading: query.isLoading,
    isError: query.isError,
    refetchPensionConfigs: query.refetch,
  }
}
